'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useShopifyCart } from '../../shopify/useShopifyCart';

const defaultCartState = {
  cartId: null,
  couponCode: null,
  isLoading: false,
  addPromo: offerCode => Promise.resolve(null),
};

export const ShopifyCartContext = createContext(defaultCartState);

export const resolveShopifyCartFlags = (isReady, pathname) => {
  if (!isReady) {
    return { shouldCreateCart: false, hasCheckedPath: false };
  }

  return {
    shouldCreateCart: pathname.includes('/onboarding'),
    hasCheckedPath: true,
  };
};

export const ShopifyCartProvider = ({ children }) => {
  const router = useRouter();
  const [shouldCreateCart, setShouldCreateCart] = useState(false);
  const [hasCheckedPath, setHasCheckedPath] = useState(false);
  useEffect(() => {
    const { shouldCreateCart: createCart, hasCheckedPath: checkedPath } =
      resolveShopifyCartFlags(router.isReady, router.pathname);
    setShouldCreateCart(createCart);
    setHasCheckedPath(checkedPath);
  }, [router.isReady, router.pathname]);

  const cartState = useShopifyCart({
    shouldCreateCart,
    hasCheckedPath,
    pathname: router.pathname,
  });

  return (
    <ShopifyCartContext.Provider value={cartState}>
      {children}
    </ShopifyCartContext.Provider>
  );
};
export const useShopifyCartContext = () => useContext(ShopifyCartContext);
